import { action, observable } from 'mobx';
import stores from '../../../models/Stores';
import { UserIdentity } from 'cd-eft/security/UserIdentity';
import * as PRJAPI from 'cd-eft/services/eftPrjAdminApi';
import MessageCenter from '../MessageCenter/MessageCenterVM';
import { AxiosResponse } from 'axios';
import { IApplicationFlags } from 'cd-eft/models/Stores/UserProfileStore';
import { FlagDto } from 'cd-eft/_codegen_/openapi-generator/eft-prjadmin';

const AppStore = stores.AppStore;
const appConfig = AppStore.appConfig;

export class EAuthLoginVM {
  props: any;
  history: any;
  constructor(props: undefined, history) {
    this.props = props;
    this.history = history;
  }

  @action.bound redirectToLogin() {
    window.open(appConfig.eAuthBasePath, '_self');
  }
}
